// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import moment from 'moment-timezone'
import {
  LOCAL_STORAGE_STATE_TO_CALENDAR,
  LOCAL_STORAGE_STATE_TO_PAST_VISIT,
  MANAGEMENT_CALENDAR_ROUTE,
  NEW_VISIT_VISITS_ROUTE,
  tableViewOptions,
  VISITS_LABEL,
  VISITS_PAGE_ROUTE,
} from '../../utils/constants'
import { visitTableView, filterRowTypeAPI, UNASSIGNED_PROVIDER_TEXT } from './constants'

const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

export const getFullNameWithPrfix = ({ FirstName, LastName, Prefix, Suffix }: ProviderNameParts) => {
  let name
  name = Prefix ? `${Prefix} ` : ''
  name += FirstName ? `${FirstName} ` : ''
  name += LastName ? `${LastName} ` : ''
  name += Suffix ? `${Suffix} ` : ''

  return name
}

type ProviderNameParts = {
  ProviderId?: string | null
  FirstName?: string | null
  LastName?: string | null
  Prefix?: string | null
  Suffix?: string | null
}

export const getProviderDisplayName = (Provider?: ProviderNameParts | null) =>
  Provider && Object.keys(Provider).length ? getFullNameWithPrfix(Provider) : UNASSIGNED_PROVIDER_TEXT

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getFullName = ({ FirstName, LastName }) => {
  let name
  name = FirstName ? `${FirstName} ` : ''
  name += LastName ? `${LastName} ` : ''

  return name
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const onHandleLinkToCalendar = ({ VisitId, Provider, stateFilter }) => {
  if (!Provider?.ProviderId) return
  const stateToCalendar = {
    visitId: VisitId,
    providerName: getFullNameWithPrfix(Provider),
    providerId: Provider.ProviderId,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty-string timezone must fall back to the current zone
    timezone: stateFilter.timeZone || currentTimeZone,
    label: VISITS_LABEL,
    route: VISITS_PAGE_ROUTE,
    newVisitRoute: NEW_VISIT_VISITS_ROUTE,
    calendarRoute: MANAGEMENT_CALENDAR_ROUTE,
    openCalendarDetails: true,
  }
  localStorage.setItem(LOCAL_STORAGE_STATE_TO_CALENDAR, JSON.stringify(stateToCalendar))
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const onHandleLinkToVisit = ({ VisitId, PatientId, Provider }) => {
  const stateToPastVisit = { patientId: PatientId, visitId: VisitId, provider: Provider }
  localStorage.setItem(LOCAL_STORAGE_STATE_TO_PAST_VISIT, JSON.stringify({ [VisitId]: stateToPastVisit }))
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getFilterRowAPI = (filterType, selectedStatusesIdsList) =>
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  selectedStatusesIdsList.map((visitStatusId, idx) => `${filterType}[${idx}]=${visitStatusId}`).join('&')

export const getVisitSearchParams = () => {
  const queryString = window.location.search
  const searchParams = new URLSearchParams(queryString)
  const { dateRange, searchValue, visitMode, visitStatus, visitTypes, tags } = Object.fromEntries(searchParams)
  const searchParamsValues = {}

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkIsSearchParamValidJSON = (jsonString, defaultValue) => {
    try {
      const parsedVisitStatus = JSON.parse(jsonString)
      return parsedVisitStatus
    } catch (e) {
      return defaultValue
    }
  }

  const getVisitMode = () => {
    const isVisitModeFromParamsValid = visitMode === visitTableView.PAST

    if (isVisitModeFromParamsValid) {
      return visitMode
    }
    return tableViewOptions[0]
  }

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.initialSearchValue = searchValue ?? ''
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.initialVisitsMode = getVisitMode()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.initialStatusFilter = checkIsSearchParamValidJSON(visitStatus, '')
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.initialVisitTypes = checkIsSearchParamValidJSON(visitTypes, '')
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.initialTagFilter = checkIsSearchParamValidJSON(tags, '')
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.initialDateRange = checkIsSearchParamValidJSON(dateRange, '')

  // Parse Active Flags
  const flagFilters = ['IsNewForPatient', 'IsNewForServiceType']
  // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
  const activeFlags = []

  flagFilters.forEach((flag) => {
    const flagValue = searchParams.get(flag)
    if (flagValue === 'true') {
      activeFlags.push(flag)
    }
  })

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  searchParamsValues.activeFlags = [...new Set(activeFlags)]

  Object.values(filterRowTypeAPI).forEach((filterType) => {
    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    const filterParams = []
    // Extract all parameters that start with the current filter type
    searchParams.forEach((value, key) => {
      if (key.startsWith(`${filterType}[`)) {
        filterParams.push(value)
      }
    })
    if (filterParams.length > 0) {
      // Assign to corresponding initial filter rows
      switch (filterType) {
        case filterRowTypeAPI.TAGS:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          searchParamsValues.initialTagsFilter = filterParams
          break
        case filterRowTypeAPI.DRUG_SCREEN_STATUSES:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          searchParamsValues.initialDrugScreenStatuses = filterParams
          break
        case filterRowTypeAPI.IDENTITY_VERIFICATION_STATUSES:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          searchParamsValues.initialIdentityVerificationStatuses = filterParams
          break
        case filterRowTypeAPI.STATUSES:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          searchParamsValues.initialStatusFilter = filterParams
          break
        default:
          console.warn('Unknown filter type:', filterType)
          break
      }
    }
  })

  return searchParamsValues
}
